import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnsupportedBrowserComponent } from './unsupported-browser.component';
import { UnsupportedBrowserService } from './unsupported-browser.service';

@NgModule({
  imports: [CommonModule],
  declarations: [UnsupportedBrowserComponent],
  providers: [UnsupportedBrowserService],
  exports: [UnsupportedBrowserComponent]
})
export class UnsupportedBrowserModule {}
